import React, { Component, Fragment } from "react";
import {
  withRouter,
  Axios,
  TableBody,
  TableRow,
  TableCell,
  DataTable,
  DataTableHead,
  DataTablePagination,
  Loading,
  Button,
  ApiUrl,
  Row,
  Col,
} from "../../../../../../../components";
// import Filters from "./Filters";
const { API_GET_HEADER_SETS } = ApiUrl;

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "header",
    align: false,
    disablePadding: true,
    label: "Name",
  },
];

class ListAll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.editId,
      columns: columnData,
      data: [],
      totalCount: 0,
      rowsPerPage: 20,
      page: 0,
      order: -1,
      fieldName: "firstname",
      status: this.props.listType,
      fieldValue: "",
      orderBy: "created_at",
      customerSearch: "",
      open: false,
      selectedId: "",
      limit: 20,
      show: true,
    };
  }
  componentDidMount = () => {
    this.getTableRecords(this.state.order, this.state.orderBy);
  };

  handleChangePage = (event, page) => {
    this.setState(
      { page: page },
      () => this.setState({ limit: event.target.value })
      // this.getTableRecords(this.state.order, this.state.orderBy)
    );
  };

  handleRequestSort = (data) => {
    if (data.key !== "action") {
      let NewColoumns = this.state.columns.map((key, index) => {
        if (key.id !== data.key) {
          return { ...key, order: 1 };
        } else {
          return { ...key, order: data.order };
        }
      });

      this.setState(
        {
          loading: true,
          columns: NewColoumns,
          orderBy: data.key,
          order: data.order,
        },
        () => this.getTableRecords(data.order, data.key)
      );
    }
  };

  getTableRecords = async (order, orderBy) => {
    const { fieldName, fieldValue, page, rowsPerPage, status, id } = this.state;
    this.setState({ loading: true });
    let body = {
      orderBy: orderBy,
      order: order,
      page: parseInt(page) + 1,
      status: status,
      // limit: rowsPerPage,
    };
    if (fieldName || fieldValue) {
      body.fieldName = fieldName;
      body.fieldValue = fieldValue;
    }
    Axios.get(API_GET_HEADER_SETS + id, body)
      .then((response) => {
        response = response.data;
        this.setState({
          data: response.data,
          totalCount: response.data.length,
          loading: false,
        });
      })
      .catch((err) => {
        console.log("");
        this.setState({ loading: false });
      });
  };

  handleChange = (event) => {
    console.log(event);
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  filterData = (e) => {
    e.preventDefault();
    this.getTableRecords(-1, "created_at");
  };

  removefilterbutton = () => {
    this.setState(
      {
        totalCount: 0,
        rowsPerPage: 10,
        page: 0,
        order: 1,
        fieldName: "name",
        fieldValue: "",
        orderBy: "created_at",
      },
      () => {
        this.getTableRecords(-1, "created_at");
      }
    );
  };
  handleClickOpen = (id) => {
    this.setState({
      open: true,
      selectedId: id,
    });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  copyToClipboard = (e) => {
    navigator.clipboard.writeText(e);
  };
  render() {
    const {
      data,
      fieldName,
      fieldValue,
      rowsPerPage,
      page,
      totalCount,
      loading,
      limit,
      show,
      status,
    } = this.state;

    return (
      <Fragment>
        {/* <Filters
          fieldName={fieldName}
          handleChange={this.handleChange}
          fieldValue={fieldValue}
          filterData={this.filterData}
          removefilter={this.removefilterbutton}
          exportButton={{
            file: "Users.csv",
            columns: { columnData },
            url: API_GET_HEADER_SETS,
            params: {
              orderBy: "createdBy",
              order: "-1",
              fieldName: fieldName,
              fieldValue: fieldValue,
              page: 0,
              limit: totalCount,
              status: status,
            },
          }}
        /> */}
        <div className="d-flex pagination-text-m justify-content-end">
          <span className="pto-5">Show</span>
          <select
            class="form-select page-select12-m"
            aria-label="Default select example"
            onChange={(event) => this.setState({ limit: event.target.value })}
          >
            <option selected>20</option>
            <option value="50">50</option>
            <option value="80">80</option>
            <option value="100">100</option>
            <option value={data.length}>{data.length}</option>
          </select>
          <span className="pto-5"> per page from {data.length} results </span>
          <div className="grid-filter-cn">
            <span className="grid-filter-txt">Filter View</span>
            <span
              className="grid-filter-txt-i"
              onClick={(prev) => this.setState({ ...prev, show: !show })}
            >
              <i class="zmdi zmdi-view-module"></i>
            </span>
            <span
              className="grid-filter-txt-i"
              onClick={(prev) => this.setState({ ...prev, show: !show })}
            >
              <i class="zmdi zmdi-view-headline"></i>
            </span>
          </div>
        </div>
        <div className="flex-auto">
          {show == true ? (
            <Row>
              <Col
                md={4}
                tabIndex={-1}
                style={{ padding: "0px" }}
              >
                <div className="header-grid-design">
                  <div className="p-1 header-design-2">
                    <span className="mr-1">1</span>
                    <span className="w-ty" id="textbox">
                      Case Number
                    </span>
                  </div>
                  <div>
                    <Button
                      className="copy-btn"
                      onClick={(e) => this.copyToClipboard("${Case_Nom}")}
                    >
                      Copy
                    </Button>
                  </div>
                </div>
              </Col>
              {data.length > 0 &&
                data.slice(0, limit).map((Dkey, index) => {
                  return (
                    <Col
                      md={4}
                      tabIndex={-1}
                      key={Dkey._id}
                      style={{ padding: "0px" }}
                    >
                      <div className="header-grid-design">
                        <div className="p-1 header-design-2">
                          <span className="mr-1">
                            {index === 0 ? 2 : index + 2 + page * rowsPerPage}
                          </span>
                          <span className="w-ty" id="textbox">
                            {`${Dkey.header}`}
                          </span>
                        </div>
                        <div>
                          <Button
                            className="copy-btn"
                            onClick={() =>
                              this.copyToClipboard(`\${${Dkey.header}}`)
                            }
                          >
                            Copy
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          ) : (
            <div className="table-responsive-material">
              <DataTable className="">
                <DataTableHead
                  columns={this.state.columns}
                  orderBy={this.state.orderBy}
                  sort={this.handleRequestSort}
                />
                <DataTableBody2
                  loading={loading}
                  column={this.state.columns}
                  data={data}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  limit={limit}
                  // copyToClipboard={this.copyToClipboard}
                />
                {/* {data.length > 0 && (
                <DataTablePagination
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={(event)=>this.handleChangePage(event)}
                  rowsPerPageOptions={[]}
                />
              )} */}
              </DataTable>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

class DataTableBody2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyText: "",
    };
  }
  handleCopyText = (e) => {
    this.setState({ copyText: e.target.value });
  };

  copyToClipboard = (e) => {
    navigator.clipboard.writeText(e);
    // document.getElementById("clipboard")
    //     .innerHTML = e;
  };

  render() {
    const { loading, page, rowsPerPage, data, column, limit } = this.props;
    return (
      <TableBody>
        {loading === false && data.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              No data Found!
            </TableCell>
          </TableRow>
        )}
        {loading === true && (
          <TableRow>
            <TableCell align="center" colSpan={9}>
              <Loading />
            </TableCell>
          </TableRow>
        )}
        <TableCell padding="none" align="left" style={{ width: "120px" }}>
          1
        </TableCell>
        <TableCell padding="none" align="left">
          <div className="d-flex justify-content-between">
            <span className="w-ty" id="textbox">
              Case Number
            </span>
            <Button
              className="copy-btn"
              onClick={(e) => this.copyToClipboard("${Case_Nom}")}
            >
              Copy
            </Button>
          </div>
        </TableCell>
        {loading === false &&
          data.length > 0 &&
          data.slice(0, limit).map((Dkey, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={Dkey._id}
                style={{ height: "45px" }}
              >
                <TableCell
                  padding="none"
                  align="left"
                  style={{ width: "120px" }}
                >
                  {index === 0 ? 2 : index + 2 + page * rowsPerPage}
                </TableCell>
                <TableCell padding="none" align="left">
                  <div className="d-flex justify-content-between">
                    <span className="w-ty" id="textbox">
                      {`${Dkey.header}`}
                    </span>
                    <Button
                      className="copy-btn"
                      onClick={(e) => this.copyToClipboard(`\${${Dkey.header}}`)}
                    >
                      Copy
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    );
  }
}

export default withRouter(ListAll);
